import { useRouter } from 'next/router';
import { abbreviate } from '@chainflip/utils/string';
import { Layout } from '../../../components/v2/Layout';
import OperatorContent from '../../../components/v2/operator/OperatorContent';

export default function Page() {
  const router = useRouter();

  const { id: operatorId } = router.query;
  // TODO(delegation): Handle operatorId being undefined or not a string
  if (!operatorId || typeof operatorId !== 'string' || !operatorId.startsWith('cF')) return null;

  return (
    <Layout title={`Operator ${abbreviate(operatorId)}`}>
      <OperatorContent idSs58={operatorId as `cF${string}`} backPath="/operators" />
    </Layout>
  );
}
